module.exports = "#formForm {\n  padding: 15px 0;\n}\n.input-group-prepend {\n  height: 100%;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/forms/forms.component.css
// module id = ./src/app/components/forms/forms.component.css
// module chunks = main